import { Flex, Spinner, Text } from "@chakra-ui/react";
import { isGiftWrapUnlocked, unlockGiftWrap } from "applesauce-common/helpers";
import { GiftWrapsModel } from "applesauce-common/models";
import { useActiveAccount, useEventModel } from "applesauce-react/hooks";
import { useEffect, useRef, useState } from "react";

export default function PendingLockedAlert() {
  const account = useActiveAccount()!;
  const locked = useEventModel(GiftWrapsModel, account ? [account.pubkey, true] : undefined);
  const [decrypting, setDecrypting] = useState(false);
  const decryptingRef = useRef(false);

  // Auto-decrypt locked gift wraps as they arrive
  useEffect(() => {
    if (!account || !locked || locked.length === 0 || decryptingRef.current) return;

    decryptingRef.current = true;
    setDecrypting(true);

    (async () => {
      for (const giftWrap of locked) {
        if (isGiftWrapUnlocked(giftWrap)) continue;
        try {
          await unlockGiftWrap(giftWrap, account);
        } catch (error) {
          if (error instanceof Error && error.message.toLocaleLowerCase().includes("user")) break;
        }
      }
      decryptingRef.current = false;
      setDecrypting(false);
    })();
  }, [locked, account]);

  if (!locked || locked.length === 0) return null;

  return (
    <Flex align="center" justify="center" gap="2" py="2" px="3">
      <Spinner size="xs" color="gray.500" />
      <Text fontSize="xs" color="gray.500">
        Decrypting {locked.length} message{locked.length !== 1 ? "s" : ""}...
      </Text>
    </Flex>
  );
}
